import { gql, useLazyQuery } from "@apollo/client";
import { useDispatch } from "react-redux";
import { GET_APPOINTMENT_NOTE, GET_CLIENT_NOTES, GET_CLIENT_STATS } from "../../constants";

const GET_APPOINTMENT_NOTES_QUERY = gql`
query GetAppointmentNote($appointmentId: Int, $consentFormId: Int) {
  getAppointmentNote(appointmentId: $appointmentId, consentFormId: $consentFormId) {
    success
    message
    data {
      appointmentId
      appointmentNote
    }
  }
}
`;

export const GetAppointmentNotes = (skipReducer = false) => {
    const dispatch = useDispatch();
    const [getAppointmentsData, appointmentNotesData] = useLazyQuery(
        GET_APPOINTMENT_NOTES_QUERY,
        {
            fetchPolicy: "cache-and-network",
            nextFetchPolicy: "cache-and-network",
            onCompleted: ({ getAppointmentNote: responseData }) => {
                console.log("client note", responseData)
                if(skipReducer) return;
                
                dispatch({
                    type: GET_APPOINTMENT_NOTE,
                    payload: responseData.data,
                });
            },
        }
    );
    const appointmentNotesQueryData = appointmentNotesData;
    const initGetAppointmentNotes = (data, scb) => {
        getAppointmentsData({
            variables: data,
        }).then((response) => {
            scb && scb(response?.data?.getAppointmentNote?.data);
        })
    };
    return { initGetAppointmentNotes, appointmentNotesQueryData };
};
